
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/upsc-environment-book",
      function () {
        return require("private-next-pages/upsc-environment-book/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/upsc-environment-book"])
      });
    }
  